/**
 * Theme Requirements Aggregation for Dietz Property Group
 * 
 * Extends the base rise theme requirements with Dietz Property Group specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-rise/requirements';

/**
 * Dietz Property Group component requirement overrides.
 * Add requirements for any override components here.
 */
const dietzpropertygroupOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Dietz Property Group theme.
 * Inherits from rise theme and overrides with Dietz Property Group components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...dietzpropertygroupOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
